import { render } from "./Rank.vue?vue&type=template&id=5d16f1e9&scoped=true"
import script from "./Rank.vue?vue&type=script&lang=js"
export * from "./Rank.vue?vue&type=script&lang=js"

import "./Rank.vue?vue&type=style&index=0&id=5d16f1e9&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d16f1e9"]])

export default __exports__